import { Feature, t } from "util/stdtypes";
import { SpacesConfig, SpaceTemplate } from "feature/editorial-dash/spaces";

export const ConversationHelperTemplate : SpaceTemplate = {
    key: 'conversation-helper',
    label: t('Conversation Helper'),
    imageUrl: 'images/conversation-helper.svg',
    structureKey: 'question',
    featuresEnabled: ['conversationhelper'],
}

export const ConversationHelperTemplateFeature : Feature<SpacesConfig, {}> = {
    key: 'conversation-helper-template',
    name: 'Conversation Helper Template',
    providesConfig: {
        templates: [ConversationHelperTemplate]
    }
}
